module.exports = __webpack_public_path__ + "img/John_Julie_Nixon@2x.9bc4f41b.png";